<template>
  <!-- eslint-disable -->
  <v-container fluid class="current-flights-map-vue shared-maps" id="current-flights-map-vue" style="padding: 0 !important;">
    <v-slide-y-transition mode="out-in">
      <div style="height: 100%">
        <div id="map" class="map" style="height:100%;z-index:0;"></div>
        <v-card class="legend shown-legend" style="border-radius: 0;">
          <v-btn outlined color="#2196f3" style="margin-right: 15px;" class="show-button" @click="showData = true;" v-if="(selectedFlight || selectedAirport) && !showData">Show</v-btn>
          <v-btn outlined color="#990000" class="outer-close-button" @click="clearSelection()" v-if="(selectedFlight || selectedAirport) && !showData">Close</v-btn>
          <div class="dataWindow" v-if="(selectedFlight || selectedAirport) && showData">
            <v-btn outlined style="margin: 10px 0 10px 10px;" color="#2196f3" class="hide-button" @click="showData = false;">Hide</v-btn>
            <v-btn outlined style="margin: 10px 10px 10px 0;" color="#990000" class="close-button" @click="clearSelection()">Close</v-btn>
            <div class="dataWindowData" style="width: 100%">
              <table v-if="selectedFlight" class="selected-flight-table">
                <tr><td>Flight&emsp;</td><td style="padding-left: 10px;"><a :href="'https://flightaware.com/live/flight/' + selectedFlight.ident" target="_blank">{{selectedFlight.ident}}</a></td></tr>
                <tr><td>Origin&emsp;</td><td style="padding-left: 10px;" class="table-origin"><a :href="'https://flightaware.com/live/airport/' + selectedFlight.orig" target="_blank">{{selectedFlight.orig}}</a></td></tr>
                <tr><td>Destination&emsp;</td><td style="padding-left: 10px;" class="table-dest"><a :href="'https://flightaware.com/live/airport/' + selectedFlight.dest" target="_blank">{{selectedFlight.dest}}</a></td></tr>
                <tr v-if="selectedFlight.origdest && selectedFlight.dest && selectedFlight.origdest !== selectedFlight.dest"><td>Original Destination&emsp;</td><td  style="padding-left: 10px;" class="table-orig-dest"><a :href="'https://flightaware.com/live/airport/' + selectedFlight.origdest" target="_blank">{{selectedFlight.origdest}}</a></td></tr>
                <tr><td>Status&emsp;</td><td style="padding-left: 10px;">{{flightStatuses[selectedFlight.status]}}</td></tr>
                <tr><td>Departure Time&emsp;</td><td style="padding-left: 10px;">{{(new Date(selectedFlight.tdep * 1000)).toLocaleString("en-US", dateFormatOptions)}}</td></tr>
                <tr><td>Arrival Time&emsp;</td><td style="padding-left: 10px;">{{(new Date(selectedFlight.tarr * 1000)).toLocaleString("en-US", dateFormatOptions)}}</td></tr>
                <tr><td>ETA (mins)&emsp;</td><td style="padding-left: 10px;">{{getMinToArrival(selectedFlight.tarr)}}</td></tr>
                <tr><td>Depart. Mins. Late&emsp;</td><td style="padding-left: 10px;">{{selectedFlight.deplm.toLocaleString()}}</td></tr>
                <tr><td>Arrival Mins. Late&emsp;</td><td style="padding-left: 10px;">{{selectedFlight.arrlm.toLocaleString()}}</td></tr>
                <tr v-if="selectedFlight.current && selectedFlight.current.cl"><td>Clock Time&emsp;</td><td style="padding-left: 10px;">{{(new Date(selectedFlight.current.cl * 1000)).toLocaleString("en-US", dateFormatOptions)}}</td></tr>
                <tr v-if="selectedFlight.current && selectedFlight.current.gs"><td>Ground Speed&emsp;</td><td style="padding-left: 10px;">{{selectedFlight.current.gs}}</td></tr>
                <tr v-if="selectedFlight.current && selectedFlight.current.al"><td>Altitude&emsp;</td><td style="padding-left: 10px;">{{selectedFlight.current.al.toLocaleString()}}</td></tr>
              </table>
              <div v-if="selectedAirport" class="selected-airport-table">
                <h4><a :href="'https://flightaware.com/live/airport/' + selectedAirport.id">{{selectedAirport.name}}</a></h4>
                <h5>{{selectedAirport.city}}, {{selectedAirport.state}}</h5>
                <div v-for="dataSet in selectedAirport.tableData" :key="dataSet.headerLabel">
                  <div v-if="dataSet.data.length > 0">
                    <h3>{{dataSet.headerLabel}}</h3>
                    <table>
                      <tr><td>Flight&emsp;</td><td style="padding-left: 10px;">{{dataSet.locationLabel}}&emsp;</td><td style="padding-left: 10px;">{{dataSet.timeLabel}}&emsp;</td></tr>
                      <tr v-for="flight in dataSet.data" :key="flight.id">
                        <td><a 
                          :class="{diverted: (flight.dest && flight.origdest && flight.dest !== flight.origdest)}" 
                          :href="'https://flightaware.com/live/flight/' + flight.ident" 
                          target="_blank"
                          >{{flight.ident}}<span class="origdest-code" style="display: none;">{{flight.origdest}}</span></a>&emsp;
                        </td>
                        <td style="padding-left: 10px;"><a :href="'https://flightaware.com/live/airport/' + flight[dataSet.locationKey]" target="_blank" class="airport-locations">{{flight[dataSet.locationKey]}}</a>&emsp;</td>
                        <td style="padding-left: 10px;">{{(new Date(flight[dataSet.timeKey] * 1000)).toLocaleString("en-US", dateFormatOptions)}}&emsp;</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <v-layout style="padding: 0 0 0 15px; flex-wrap: nowrap; margin: 0;" row>
              <v-icon class="ups-flight">airplanemode_active</v-icon>
              <v-flex xs6 class="vert-center">UPS</v-flex>
              <v-checkbox class="vert-center ups-flight-toggle" v-model="showUps" @change="clearSelection(); drawMarkers();" style="margin: 0 0 0 15px; padding: 0; height: auto;"></v-checkbox>
            </v-layout>
            <v-layout style="padding: 0 0 0 15px; flex-wrap: nowrap; margin: 0;" row>
              <v-icon class="fdx-flight">airplanemode_active</v-icon>
              <v-flex xs6 class="vert-center">FedEx</v-flex>
              <v-checkbox class="vert-center fdx-flight-toggle" v-model="showFedEx" @change="clearSelection(); drawMarkers();" style="margin: 0 0 0 15px; padding: 0; height: auto;"></v-checkbox>
            </v-layout>
          </div>
        </v-card>
        <v-progress-circular class="progress-circle-loading" :size="55" :width="5" indeterminate color="primary" v-if="loading" ></v-progress-circular>
        <!--
        <div class="progress-circle-loading" v-if="!flightPointerEvents">Flight Click Off: key f</div>
        <div class="progress-circle-loading" v-if="!airportPointerEvents">Airport Click Off: key a</div>
        -->
        <v-btn text icon class="fit-to-bounds-btn" color="grey darken-1" style="position: absolute; right: 0; top: 0;" @click="zoomToShowMarkers()">
          <v-icon dark>zoom_out_map</v-icon>
        </v-btn>
        <div style="display:none">{{drawerOpen()}}</div>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import currentFlightsMapModule, {
  CURRENT_FLIGHTS_MAP_NAMESPACE
} from "./store/currentFlightsMapStore";
import * as d3 from "d3";
// eslint-disable-next-line
import polylinedecorator from "leaflet-polylinedecorator";
import MapsMixin from "@/mixins/MapsMixin.js";
import { mapGetters } from "vuex";

export default {
  name: "CurrentFlightMap",
  mixins: [MapsMixin],
  data() {
    return {
      mapMarkers: {},
      flightsAirportMarkers: {},
      flightsActiveAirportDetails: {},
      showFedEx: true,
      showUps: true,
      showData: true,
      flightDetailMarkers: [],
      flightStatuses: {
        S: "SCHEDULED",
        F: "FILED",
        A: "ACTIVE",
        Z: "COMPLETED",
        X: "CANCELLED"
      },
      selectedAirport: null,
      selectedFlight: null,
      flightPointerEvents: true,
      airportPointerEvents: true,
      dateFormatOptions: { hour12: false, hour: "2-digit", minute: "2-digit" },
      flightsDataRefreshTime: 5 * 1000,
      flightsDetailsRefreshTime: 60 * 1000
    };
  },
  computed: {
    ...mapGetters(CURRENT_FLIGHTS_MAP_NAMESPACE, [
      "flightMarkerData",
      "flightsDetailData",
      "airportsDetailData",
      "detailFlightData"
    ])
  },
  watch: {
    drawer: /* istanbul ignore next */ function(val) {
      var grid = document.getElementById("current-flights-map-vue");
      var direction = -1;
      if (!val) direction *= -1;
      var offset = this.$store.navWidth * 0.5 * direction;
      if (grid) this.map.panBy([offset, 0], { duration: 0.2 });
    }
  },
  mounted: /* istanbul ignore next */ function() {
    this.initCurrentFlightsMap();
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(
      CURRENT_FLIGHTS_MAP_NAMESPACE,
      currentFlightsMapModule
    );
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.FLIGHTS_ADMIN]).then(
      res => {
        if (res) {
          this.loadAirportsDetails();
          this.loadFlights();
          this.loadFlightsDetails();
          var self = this;
          var flightMapDataInterval = setInterval(function() {
            self.loadFlights();
          }, this.flightsDataRefreshTime);
          this.$store.intervals.flightMapDataInterval = flightMapDataInterval;
          var flightMapDataDetailsInterval = setInterval(function() {
            self.$store.dispatch(
              `${CURRENT_FLIGHTS_MAP_NAMESPACE}/LOAD_FLIGHTS_DETAILS`
            );
          }, this.flightsDetailsRefreshTime);
          this.$store.intervals.flightMapDataDetailsInterval = flightMapDataDetailsInterval;
        } else this.$goHome();
      }
    );
  },
  methods: {
    initCurrentFlightsMap() {
      this.map = this.initMap();
      var self = this;
      /* istanbul ignore next */
      this.map.on("click", () => {
        self.clearSelection();
      });
    },
    loadFlights() {
      return this.$store
        .dispatch(`${CURRENT_FLIGHTS_MAP_NAMESPACE}/LOAD_FLIGHTS`)
        .then(() => {
          this.drawMarkers();
        });
    },
    loadFlightsDetails() {
      this.loading = true;
      return this.$store
        .dispatch(`${CURRENT_FLIGHTS_MAP_NAMESPACE}/LOAD_FLIGHTS_DETAILS`)
        .then(() => {
          this.map.closePopup();
          this.loading = false;
          this.drawMarkers();
        });
    },
    loadAirportsDetails() {
      return this.$store
        .dispatch(`${CURRENT_FLIGHTS_MAP_NAMESPACE}/LOAD_AIRPORTS_DETAILS`)
        .then(() => {
          this.drawMarkers();
        });
    },
    drawMarkers() {
      this.flightsActiveAirportDetails = {};
      var activeAirportMarkerIds = {};
      var idArray = [];
      if (Array.isArray(this.flightMarkerData))
        this.flightMarkerData.forEach(m => {
          var savedMarker = this.mapMarkers[m.id];
          // eslint-disable-next-line
          var latlng = L.latLng(m.cp.lt, m.cp.ln);
          var flightData = this.flightsDetailData[m.id];
          if (flightData && flightData.orig && flightData.dest) {
            flightData.current = m.cp;
            if (savedMarker) {
              if (
                !(
                  savedMarker._latlng.lat === latlng.lat &&
                  savedMarker._latlng.lng === latlng.lng
                )
              ) {
                let marker = this.getFlightMarker(m, latlng, flightData);
                /* istanbul ignore next */
                this.map.removeLayer(savedMarker);
                marker.addTo(this.map);
                this.mapMarkers[m.id] = marker;
              }
            } else {
              let marker = this.getFlightMarker(m, latlng, flightData);
              marker.addTo(this.map);
              this.mapMarkers[m.id] = marker;
            }
          }
          idArray.push(m.id);
          if (this.flightsDetailData[m.id] && this.showFilteredMarker(m.id)) {
            /*eslint-disable */
            if(!this.flightsActiveAirportDetails[this.flightsDetailData[m.id].orig])
              this.flightsActiveAirportDetails[this.flightsDetailData[m.id].orig] = {orig: {}, dest: {}};
            if (!this.flightsActiveAirportDetails[this.flightsDetailData[m.id].dest])
              this.flightsActiveAirportDetails[this.flightsDetailData[m.id].dest] = {orig: {}, dest: {}};
            /* istanbul ignore else */
            if(this.flightsDetailData[m.id].orig)
              this.flightsActiveAirportDetails[this.flightsDetailData[m.id].orig]["orig"][m.id] = this.flightsDetailData[m.id];
            /* istanbul ignore else */
            if(this.flightsDetailData[m.id].dest)
              this.flightsActiveAirportDetails[this.flightsDetailData[m.id].dest]["dest"][m.id] = this.flightsDetailData[m.id];
            activeAirportMarkerIds[this.flightsDetailData[m.id].orig] = true;
            activeAirportMarkerIds[this.flightsDetailData[m.id].dest] = true;
            activeAirportMarkerIds[this.flightsDetailData[m.id].origdest] = true;
            /*eslint-enable */
          }
        });
      for (let code in this.airportsDetailData) {
        if (activeAirportMarkerIds[code]) {
          if (!this.flightsAirportMarkers[code]) {
            this.flightsAirportMarkers[code] = this.getAirportMarker(
              this.airportsDetailData[code]
            );
            this.flightsAirportMarkers[code].addTo(this.map);
          }
          if (this.flightsActiveAirportDetails[code])
            // eslint-disable-next-line
            this.airportsDetailData[code].tableData = this.getAirportTableData(this.flightsActiveAirportDetails[code]);
        } else {
          if (this.flightsAirportMarkers[code]) {
            this.map.removeLayer(this.flightsAirportMarkers[code]);
            this.flightsAirportMarkers[code] = null;
          }
          this.airportsDetailData[code].activeFlights = {
            orig: {},
            dest: {},
            origdest: {}
          };
        }
      }

      for (let id in this.mapMarkers) {
        /* istanbul ignore if */
        if (
          idArray.filter(x => {
            return x === id;
          }).length === 0
        ) {
          this.map.removeLayer(this.mapMarkers[id]);
        } else {
          if (
            !this.showFilteredMarker(id) ||
            (this.flightsDetailData[id] &&
              this.flightsDetailData[id].status !== "A")
          ) {
            this.map.removeLayer(this.mapMarkers[id]);
            delete this.mapMarkers[id];
          }
        }
      }
    },
    getAirportTableData(data) {
      var tableData = {
        Arrivals: {
          data: [],
          headerLabel: "Arrivals",
          locationLabel: "Origin",
          locationKey: "orig",
          timeKey: "tarr",
          timeLabel: "Est. Arr."
        },
        Departures: {
          data: [],
          headerLabel: "Departures",
          locationLabel: "Dest.",
          locationKey: "dest",
          timeKey: "tdep",
          timeLabel: "Depart."
        },
        Scheduled: {
          data: [],
          headerLabel: "Scheduled",
          locationLabel: "Dest.",
          locationKey: "dest",
          timeKey: "tdep",
          timeLabel: "Est. Depart."
        },
        Landed: {
          data: [],
          headerLabel: "Landed",
          locationLabel: "Origin",
          locationKey: "orig",
          timeKey: "tarr",
          timeLabel: "Arrival"
        }
      };

      for (let flight in data["dest"]) {
        let flightDetail = this.flightsDetailData[flight];
        if (flightDetail) {
          if (flightDetail.status === "A")
            tableData.Arrivals.data.push(flightDetail);
          else tableData.Landed.data.push(flightDetail);
        }
      }
      for (let flight in data["orig"]) {
        let flightDetail = this.flightsDetailData[flight];
        if (flightDetail) {
          if (flightDetail.status === "A")
            tableData.Departures.data.push(flightDetail);
          else tableData.Scheduled.data.push(flightDetail);
        }
      }
      return tableData;
    },
    getFlightPopupHtml(point) {
      var flightData = this.flightsDetailData[point.id];
      if (flightData)
        // eslint-disable-next-line
        return `<div class="popup-div">${point.fl}<br>${flightData.orig.substring(1)} ${flightData.dest.substring(1)}<br>${(new Date(flightData.tarr * 1000)).toLocaleString("en-US", this.dateFormatOptions)}/${this.getMinToArrival(flightData.tarr)}m<div>`;
    },
    getMinToArrival(arrival) {
      var now = Date.now();
      var arr = new Date(arrival * 1000);
      return Math.floor((arr - now) / 1000 / 60);
    },
    getFlightMarker(point, latlng, flightData) {
      var iconSize = 35;
      var className = "airplane-marker";
      if (this.selectedFlight && this.selectedFlight.id !== point.id)
        className = "map-marker-fade";
      if (this.selectedAirport && flightData) {
        // eslint-disable-next-line
        if (flightData.orig !== this.selectedAirport.id && flightData.dest !== this.selectedAirport.id) className = "map-marker-fade";
      }
      if ((point.id + "").includes("UPS")) className += " ups-flight";
      else if ((point.id + "").includes("FDX")) className += " fdx-flight";
      else className += " unknown-flight";
      // eslint-disable-next-line
      if(flightData && flightData.dest && flightData.origdest && flightData.dest !== flightData.origdest){
        className += " diverted-flight";
      }
      // eslint-disable-next-line
      var icon = new L.DivIcon({
        html: this.getFlightIconHtml(point, iconSize, flightData),
        className: className,
        // eslint-disable-next-line
        iconSize: null
      });
      // eslint-disable-next-line
      var marker = L.marker(latlng, { icon: icon });
      var self = this;
      /* istanbul ignore next */
      var startPopup = function() {
        // eslint-disable-next-line
        L.popup()
          .setLatLng(marker._latlng)
          .setContent(self.getFlightPopupHtml(point))
          .openOn(self.map);
      };
      /* istanbul ignore next */
      marker
        .on("click", () => {
          this.showFlightPath(point.id, latlng, self);
          this.selectFlight(point.id);
          this.map.closePopup();
        })
        .on("dblclick", () => {
          this.selectFlight(point.id);
          this.showFlightPath(point.id, latlng, self);
          var flightDetail = this.flightsDetailData[point.id];
          if (flightDetail) {
            var latlngArray = [
              latlng,
              {
                lat: this.airportsDetailData[flightDetail.orig].lat,
                lng: this.airportsDetailData[flightDetail.orig].lon
              },
              {
                lat: this.airportsDetailData[flightDetail.dest].lat,
                lng: this.airportsDetailData[flightDetail.dest].lon
              }
            ];
            this.map.fitBounds(latlngArray, { padding: [100, 100] });
          }
        })
        .on("mouseover", () => {
          startPopup();
        })
        .on("mouseout", () => {
          this.map.closePopup();
        });

      return marker;
    },
    getFlightIconHtml(point, iconSize, flightData) {
      var strokeWidth = 1;
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var s = d3.select(svg);
      s.attr("width", iconSize)
        .attr("height", iconSize)
        .attr("viewBox", "0 0 24 24")
        .style("overflow", "visible")
        // eslint-disable-next-line
        .style("transform", "translate(" + -iconSize / 2 + "px ," + -iconSize / 2 + "px) rotate(" + point.cp.hd + "deg)")
        .attr("class", "airplane-icon")
        .append("path")
        .attr("stroke-width", strokeWidth)
        .attr(
          "d",
          "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
        );

      return this.serializeXmlNode(svg);
    },
    getAirportIconHtml(airport) {
      var iconSize = 20;
      var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      var s = d3.select(svg);
      s.attr("width", 50)
        .attr("height", 45)
        // eslint-disable-next-line
         .style("transform", "translate(" + -iconSize / 2 + "px ," + -iconSize / 2 + "px)")
        .attr("class", "airplane-icon")
        .append("circle")
        .attr("fill", "blue")
        .attr("stroke", "#000")
        .attr("stroke-width", 2)
        .attr("cx", iconSize / 2)
        .attr("cy", iconSize / 2)
        .attr("r", iconSize / 2 - 1);
      s.append("text")
        .attr("pointer-events", "none")
        .attr("text-anchor", "middle")
        .attr("dy", ".30em")
        .style("font-size", 14 + "px")
        .style("font-weight", "600")
        .attr("fill", "#000")
        .style(
          "text-shadow",
          "-2px 0 white, 0 2px white, 2px 0 white, 0 -2px white"
        )
        .attr("x", 25)
        .attr("y", 30)
        .text(airport.id);

      return this.serializeXmlNode(svg);
    },
    showFilteredMarker(id) {
      if (id.includes("UPS")) return this.showUps;
      else if (id.includes("FDX")) return this.showFedEx;
      else return true;
    },
    showFlightPath: /* istanbul ignore next */ function(id, key) {
      var flightDetail = this.flightsDetailData[id];
      if (flightDetail && this.showFilteredMarker(id)) {
        var points = [];
        flightDetail.waypoints.forEach(point => {
          points.push([point[1], point[0]]);
        });
        // eslint-disable-next-line
        if (flightDetail != null && flightDetail.dest && flightDetail.origdest && flightDetail.dest !== flightDetail.origdest){
          key = "diverted-path";
        }
        // eslint-disable-next-line
        var polyLine = new L.Polyline(points, {
          color: this.getLineColor(key),
          className: "filed-flight-path " + key,
          weight: 1,
          opacity: 1,
          smoothFactor: 1,
          dashArray: "10 4"
        });
        // eslint-disable-next-line
        var polyLineDeco = L.polylineDecorator(points, {
          // eslint-disable-next-line
          patterns: [{offset: 25, repeat: 50, symbol: L.Symbol.arrowHead({pixelSize: 7, pathOptions: {fillOpacity: .7, weight: 0, fillColor: this.getLineColor(key)}})}]
        });

        this.flightDetailMarkers.push(polyLine);
        polyLine.addTo(this.map);

        this.flightDetailMarkers.push(polyLineDeco);
        polyLineDeco.addTo(this.map);

        this.fadeFlights(flightDetail.dest, true);
        this.fadeFlights(flightDetail.orig, true);
        if (key === "diverted-path")
          this.fadeFlights(flightDetail.origdest, true);
      }
    },
    getLineColor(key) {
      if (key === "diverted-path") return "red";
      else return "blue";
    },
    resetFlightMarkerClasses: /* istanbul ignore next */ function(fade) {
      for (let marker in this.mapMarkers) {
        var icon = this.mapMarkers[marker]._icon;
        if (icon)
          if (fade) icon.classList.add("map-marker-fade");
          else icon.classList.remove("map-marker-fade");
      }
    },
    fadeFlights: /* istanbul ignore next */ function(code, show) {
      if (code) {
        if (this.flightsAirportMarkers[code]) {
          let icon = this.flightsAirportMarkers[code]._icon;
          if (icon) {
            if (show) icon.classList.remove("map-marker-fade");
            else icon.classList.add("map-marker-fade");
          }
        }
      } else {
        for (let c in this.flightsAirportMarkers) {
          if (this.flightsAirportMarkers[c]) {
            let icon = this.flightsAirportMarkers[c]._icon;
            if (icon) {
              if (show) icon.classList.remove("map-marker-fade");
              else icon.classList.add("map-marker-fade");
            }
          }
        }
      }
    },
    showFlightPaths: /* istanbul ignore next */ function(code, type) {
      this.fadeFlights(null, false);
      this.resetFlightMarkerClasses(true);
      if (type === "airport") {
        d3.selectAll(".airport-marker-" + this.selectedAirport.id).classed(
          "map-marker-fade",
          false
        );
        for (let detail in this.flightsActiveAirportDetails[code]) {
          for (let flight in this.flightsActiveAirportDetails[code][detail]) {
            this.showFlightPath(flight, detail);
            if (this.mapMarkers[flight]) {
              let icon = this.mapMarkers[flight]._icon;
              if (icon) icon.classList.remove("map-marker-fade");
            }
          }
        }
      } else if (type === "flight") {
        for (let flight in this.mapMarkers) {
          /* istanbul ignore next */
          if (this.mapMarkers[flight] && code === flight) {
            this.showFlightPath(flight);
            let icon = this.mapMarkers[flight]._icon;
            if (icon) icon.classList.remove("map-marker-fade");
          }
        }
      }
    },
    getAirportMarker(airport, key) {
      var className = "airport-marker airport-marker-" + airport.id;
      // eslint-disable-next-line
      var icon = new L.DivIcon({
        html: this.getAirportIconHtml(airport, key),
        className: className,
        // eslint-disable-next-line
        iconSize: null
      });
      // eslint-disable-next-line
      var marker = L.marker({lat: airport.lat, lng: airport.lon}, { icon: icon });
      var self = this;
      /* istanbul ignore next */
      marker
        .on("click", () => {
          self.selectAirport(airport.id);
        })
        .on("dblclick", () => {
          var latlngArray = [{ lat: airport.lat, lng: airport.lon }];
          for (let detail in this.flightsActiveAirportDetails[airport.id]) {
            // eslint-disable-next-line
            for (let flight in this.flightsActiveAirportDetails[airport.id][detail]) {
              var flightDetail = this.flightsDetailData[flight];
              if (flightDetail) {
                latlngArray.push({
                  lat: this.airportsDetailData[flightDetail.orig].lat,
                  lng: this.airportsDetailData[flightDetail.orig].lon
                });
                latlngArray.push({
                  lat: this.airportsDetailData[flightDetail.dest].lat,
                  lng: this.airportsDetailData[flightDetail.dest].lon
                });
              }
            }
          }
          this.map.fitBounds(latlngArray, { padding: [100, 100] });
          self.selectAirport(airport.id);
        });
      return marker;
    },
    zoomToShowMarkers: /* istanbul ignore next */ function(val) {
      var bounds = [];
      for (let id in this.mapMarkers) {
        if (
          this.mapMarkers[id]._latlng.lng !== 0 &&
          this.mapMarkers[id]._latlng.lat !== 0
        )
          bounds.push([
            this.mapMarkers[id]._latlng.lat,
            this.mapMarkers[id]._latlng.lng
          ]);
      }
      var paddingBottom = 50;
      var paddingLeft = 50;
      if (this.drawerOpen()) paddingLeft = this.$store.navWidth + 50;
      this.map.fitBounds(bounds, {
        paddingTopLeft: [paddingLeft, 50],
        paddingBottomRight: [50, paddingBottom]
      });
    },
    selectAirport(val) {
      this.selectedAirport = this.airportsDetailData[val];
      this.selectedFlight = null;
      /* istanbul ignore next */
      this.flightDetailMarkers.forEach(marker => {
        this.map.removeLayer(marker);
      });
      this.showFlightPaths(val, "airport");
      // this.showData = true;
    },
    selectFlight(val) {
      this.selectedFlight = this.flightsDetailData[val];
      this.selectedAirport = null;
      /* istanbul ignore next */
      this.flightDetailMarkers.forEach(marker => {
        this.map.removeLayer(marker);
      });
      this.showFlightPaths(val, "flight");
    },
    clearSelection() {
      this.selectedAirport = null;
      this.selectedFlight = null;
      /* istanbul ignore next */
      this.flightDetailMarkers.forEach(marker => {
        this.map.removeLayer(marker);
      });
      this.fadeFlights(null, true);
      this.resetFlightMarkerClasses();
    }
  }
};
</script>
